<ng-container *ngIf="data$.currency_list as currencies">
  <div *ngIf="currencies[data]" class="c-field-value d-flex" [ngClass]="customClass">
    <span class="c-field-value__icon d-flex">
      <img *ngIf="currencies[data].img" src="{{ currencies[data].img }}" width="20" height="20" />
    </span>
    <span class="c-field-value__text">{{ data }}</span>
  </div>
  <gtd-ui-field-default-string-or-empty
    *ngIf="!currencies[data]"
    [customClass]="customClass"
    [data]="data"
  ></gtd-ui-field-default-string-or-empty>
</ng-container>
